/* @flow */

import {
    type Package,
} from './types';
import { type Pedido } from '../pedidos/types';
import getRecipientDoPedido from './getRecipientDoPedido';
import getAddressDoPedido from './getAddressDoPedido';
import getChargeDoPedido from './getChargeDoPedido';

const getPackagesDoPedido = (pedido: Pedido): Package[] => {
    const address = getAddressDoPedido(pedido);
    const recipient = getRecipientDoPedido(pedido);
    const charge = getChargeDoPedido(pedido);

    if (!recipient || !address || !charge) {
        return [];
    }

    return [
        {
            pickupIndex: 0,
            recipient,
            address,
            charge,
        },
    ];
};

export default getPackagesDoPedido;
